import { LayoutConnectMap } from '..'
import Content from './contentConnectMap'
import { HeaderConnectMap } from './headerConnectMap'
import { Header } from './headerConnectMap/Header'
import classes from './index.module.scss'

const InterconnectionMap = () => {
  return (
    <LayoutConnectMap
      renderTopComponent={() => (
        <div style={{ padding: '0 6px' }}>
          <Header />
        </div>
      )}
      renderBottomComponent={() => (
        <div className={classes.downloadFilesMain} style={{ padding: '0 6px' }}>
          <div className="positionRelative">
            <HeaderConnectMap />
          </div>
          <Content />
        </div>
      )}
    />
  )
}

export default InterconnectionMap
